import { db } from '../components/Dexie';
import { log } from './loggingService';

/**
 * Synchronizes users with the remote API.
 * @param {boolean} force - If true, clears local data and forces a full sync.
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const syncTechyShopUsers = async (force = true) => {
  try {
    if (force) {
      log("Reset utenti techyshop locali in corso...", 'INFO');
      await db.techyshop_utenti.clear();
    }
    
    log("Avvio download utenti dal server...", 'INFO');

    const response = await fetch('https://deadapi.techysumo.it/techyshop/searchUtente', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({})
    });
    
    const result = await response.json();
    
    if (result.result && Array.isArray(result.details)) {
      const normalizedUsers = result.details.map(u => ({
        ...u,
        id: parseInt(u.id),
        attivo: (u.attivo == 1 || u.attivo === true || String(u.attivo).toLowerCase() === 'true') ? 1 : 0,
        newsletter: (u.newsletter == 1 || u.newsletter === true || String(u.newsletter).toLowerCase() === 'true') ? 1 : 0,
        email_verificata: (u.email_verificata == 1 || u.email_verificata === true || String(u.email_verificata).toLowerCase() === 'true') ? 1 : 0
      }));
      
      await db.techyshop_utenti.bulkPut(normalizedUsers);
      log(`Sincronizzati ${normalizedUsers.length} utenti.`, 'INFO');

      return { success: true, message: `Sincronizzati ${normalizedUsers.length} utenti con successo!` };
    } else {
      throw new Error(result.text || "Errore durante il download degli utenti.");
    }
  } catch (error) {
    log("Errore durante la sincronizzazione degli utenti:", 'ERROR', error);
    return { success: false, message: `Errore: ${error.message}` };
  }
};
